import React from 'react';
import styles from './LinkedContainer.module.scss';
import cx from 'classnames';
import CmsAPI from '../../../common/apis/CmsAPI';
import { useVideoProgressContext } from '../../context/VideoProgressContext';

const LinkedContainer = ({ isSharedPage, storyId, items, title, chapter = false, cta = false }) => {
  const { updateVideoSeekToValue } = useVideoProgressContext();

  const formatTime = time => {
    const minutes = Math.floor(time / 1000 / 60);
    const seconds = Math.floor((time / 1000) % 60);

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  };

  const clickOnLinkedTime = time => () => {
    updateVideoSeekToValue({ value: time / 1000, playing: true });
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const checkURLFormat = url => {
    const re = /^(http(s):\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/gm;
    return re.test(url);
  };

  const handleClickUrl = cta => {
    if (isSharedPage) {
      CmsAPI.logEvent(storyId, { eventType: 'cta_click', ctaId: cta.id });
    }
    const containsProtocol = cta.url?.startsWith('http://') || cta.url?.startsWith('https://');
    const resultUrl = containsProtocol ? cta.url : `https://${cta.url}`;

    const isValid = checkURLFormat(resultUrl);

    isValid && window.open(resultUrl, '_blank');
  };

  return (
    <>
      {items.length > 0 ? (
        <div className={cx(styles.linkedContainer)}>
          <div className={cx(styles.titleContainer)}>
            <p className={styles.containerTitle}>{title}</p>
          </div>
          <div className={styles.list}>
            {items.map(item => {
              return (
                <div key={item.id} className={styles.item}>
                  {chapter && (
                    <>
                      <div className={styles.time} onClick={clickOnLinkedTime(item.startTime)}>
                        {formatTime(item.startTime)}
                      </div>
                      <div className={styles.title}>{item.title}</div>
                    </>
                  )}
                  {cta && (
                    <>
                      <div className={styles.time} onClick={clickOnLinkedTime(item.offset)}>
                        {formatTime(item.offset)}
                      </div>
                      <div className={cx(styles.title, styles.ctaTitle)}>
                        <div className={cx(styles.text, styles.ctaText)}>{item.text}</div>
                        <span>-</span>
                        <a className={styles.url} onClick={() => handleClickUrl(item)}>
                          {item.url}
                        </a>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default LinkedContainer;
